import api from "./api";
import Menu from "@/model/menu";
import MenuSet from "@/model/menuSet";
import SetMenuItem from "@/model/setMenuItem";
import Option from "@/model/option";
import { MenuSetting, Setting } from "@/model/menuSetting";
import Category from "@/model/category";

type itemApiResponce = {
    data: {
    categories: Category[],
    items: Menu[],
    settings: Setting,
    set_menus: MenuSet[],
    set_menu_items: SetMenuItem[],
  }
};

class ItemApi extends api {
  constructor() {
    super();
    this.setup();
  }

  async getContext(): Promise<itemApiResponce> {
    const response = await this.post('items');
    if (!response?.data?.context?.length) {
      return {
        data: {
          categories: [],
          items: [],
          settings: null,
          set_menus: [],
          set_menu_items: [],
        }
      };
    }

    return JSON.parse(response.data.context);
  }

  async index(context: itemApiResponce) {
    const identifierCategories = []
    const result = []

    const items = context.data.items
    const categories = context.data.categories
    const settings = context.data.settings;
    const menuSetting = new MenuSetting();

    categories.map(category => {
      identifierCategories.push(category.identifier.toString())
    })

    const uniqueItems = [
      ...new Map(items.map(item => [item['identifier'], item])).values(),
    ]
    const dataList = JSON.parse(JSON.stringify(uniqueItems))

    dataList.map(value => {
      if (identifierCategories.includes(value.itemCategory.toString())) {
        result.push(value)
      }
    })

    result.sort((a,b) => (a.itemCategory > b.itemCategory ? 1 : -1))

    menuSetting.menus = result.map(item => {
      return new Menu({
        ...item, ...{
          quantity: 1,
          isSpicy: false
        }
      })
    });
    menuSetting.setting = settings;
    menuSetting.allRawMenus = items;

    return menuSetting;
  }

  async getSetMenu(context) {
    const setMenus = context.data.set_menus
    const setMenuItems = Object.values(context.data.set_menu_items)
    const setMenuItemKeys = Object.keys(context.data.set_menu_items)

    return {
      'setMenus': setMenus ?? [],
      'setMenuItems': setMenuItems ?? [],
      'setMenuItemKeys': setMenuItemKeys ?? []
    }
  }

  async getOptions(context) {
    const items = context.data.items
    const options = []

    items.map(item => {
      if (item.subIdentifier !== "") {
        options.push(new Option({
          identifier: item.identifier.toString(),
          subIdentifier: item.subIdentifier.toString(),
          subName: item.subName.toString(),
          subNameEn: (item.subNameEn) ? item.subNameEn.toString() : '',
          subNameCn: (item.subNameCn) ? item.subNameCn.toString() : '',
          subNameKr: (item.subNameKr) ? item.subNameKr.toString() : '',
          quantity: 0,
          minimumOrder: item.minimumOrder,
        }))
      }
    })

    return options
  }

  async getMenuSetListByIdentifier(identifier, setMenus, setMenuItemKeys, setMenuItems) {
    const setMenuList = await this.prepareSetMenuItems(setMenuItems, setMenuItemKeys)
    if (typeof setMenus[identifier.toString()] !== "undefined") {
      return setMenus[identifier.toString()].map(item => {
        if (item.item_keys.length > 0) {
          item.options = item.item_keys.map(value => {
            return new SetMenuItem(this.getSetMenuItemByIdentifier(setMenuList, value))
          })
        }
        return new MenuSet({
          identifier: identifier,
          ...item
        })
      })
    }
    return [];
  }

  async prepareSetMenuItems(setMenuItems, setMenuItemKeys) {
    const result = []
    setMenuItems.map(item => {
      result.push(item)
    })
    result.map((item, key) => item.identifier = setMenuItemKeys[key]);

    return result
  }

  async getRecommendedList(context) {
    const menuSetting = await this.index(context);
    const items = menuSetting.allRawMenus;
    const menuRecommended = []
    items.map(value => {
      if (value.ranking !== "" && Number.parseInt(value.ranking) > 0) {
        menuRecommended.push(value)
      }
    })

    return menuRecommended.sort((a,b) => (a.ranking > b.ranking ? 1 : -1))
  }

  async getMenuByIdentifier(context, identifier) {
    const menuSetting = await this.index(context);
    const items = menuSetting.menus
    const menu = []
    items.map(item => {
      if (item.identifier === identifier) {
        menu.push(item)
      }
    });

    if (menu) {
      return menu[0]
    }

    return menu
  }

  private getSetMenuItemByIdentifier(items, value) {
    let setMenuItem = new SetMenuItem();
    items.map(item => {
      if (item.identifier === value) {
        setMenuItem = new SetMenuItem({
          ...item, ...{
            quantity: 0
          }
        })
      }
    });

    return setMenuItem;
  }
}

export default new ItemApi();
